export const TYPE_POC = 'poc';
export const TYPE_WHW = 'whw';
export const TYPE_PLAYER = 'player';
export const TYPE_TABLE = 'table';
export const TYPE_HINT_HELP = 'help';
export const TYPE_HINT_ERROR = 'error';
export const TYPE_BUTTON_CLOSE = 'close';